import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import router from '@/router' // 引入路由实例（关键：用于跳转登录页）

export const SERVER_HOST = import.meta.env.VITE_BASE_URL

// 创建 Axios 实例
const service = axios.create({
    baseURL: '/api', // 假设后端运行在 8000 端口
    timeout: 10000, // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        const userStore = useUserStore()
        if (userStore.token) {
            config.headers['Authorization'] = `Bearer ${userStore.token}`
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data

        if (res.code !== 200) {
            ElMessage({
                message: res.message || '操作失败',
                type: 'error',
                duration: 5 * 1000
            })

            // 401: Token 失效或未登录 → 跳转登录页
            if (res.code === 401) {
                const userStore = useUserStore()
                userStore.logout() // 清除本地 Token 和用户信息

                // 提示登录失效
                ElMessage({
                    message: '登录已失效，请重新登录',
                    type: 'warning',
                    duration: 3 * 1000
                })

                // 跳转到登录页（带当前页面路径作为 redirect 参数，登录后可返回原页面）
                router.push({
                    path: '/login',
                    query: { redirect: router.currentRoute.value.fullPath } // 记录当前路径
                })
            }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        let message = error.message

        // 处理 HTTP 响应错误（包括 401 状态码）
        if (error.response) {
            // 后端返回的 401（Token 失效）
            if (error.response.status === 401) {
                const userStore = useUserStore()
                userStore.logout() // 清除本地 Token 和用户信息

                // 提示登录失效
                ElMessage({
                    message: '登录已失效，请重新登录',
                    type: 'warning',
                    duration: 3 * 1000
                })

                // 跳转到登录页（带重定向参数）
                router.push({
                    path: '/login',
                    query: { redirect: router.currentRoute.value.fullPath }
                })
            }

            // 其他错误信息提取
            if (error.response.data && error.response.data.detail) {
                message = error.response.data.detail
            } else if (error.response.data && error.response.data.message) {
                message = error.response.data.message
            }
        }

        ElMessage({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service